import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const AFRIMED_TYPOGRAPHY_CLASSES = new Set([
    "text-display-large",
    "text-display-medium",
    "text-display-small",
    "text-headline-large",
    "text-headline-medium",
    "text-headline-small",
    "text-title-large",
    "text-title-medium",
    "text-title-small",
    "text-label-large",
    "text-label-medium",
    "text-label-small",
    "text-body-large",
    "text-body-medium",
    "text-body-small",
]);

export function cn(...inputs) {
    const className = clsx(inputs);
    const merged = twMerge(className);
    const mergedParts = merged.split(/\s+/).filter(Boolean);
    if (mergedParts.some((part) => AFRIMED_TYPOGRAPHY_CLASSES.has(part))) {
        return merged;
    }

    const typographyClass = className
        .split(/\s+/)
        .filter((part) => AFRIMED_TYPOGRAPHY_CLASSES.has(part))
        .at(-1);

    return typographyClass ? `${typographyClass} ${merged}` : merged;
}
